import React from 'react';

const ChatsIcon = ({ color = '#A6B0CF' }) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M26.6666 20.0003V10.0003C26.6666 8.17741 25.1794 6.66699 23.3845 6.66699H8.6153C6.76915 6.66699 5.33325 8.17741 5.33325 10.0003V20.0003C5.33325 21.8753 6.76915 23.3337 8.6153 23.3337L10.2563 23.3857V26.042C10.2563 26.4587 10.5127 26.667 10.8717 26.667C10.9743 26.667 11.0768 26.667 11.2307 26.5628L16.8204 23.3337H23.3845C25.1794 23.3337 26.6666 21.8753 26.6666 20.0003ZM16.1538 20.8337L12.7179 22.8649V20.8337H8.6153C8.15376 20.8337 7.79479 20.4691 7.79479 20.0003V10.0003C7.79479 9.58366 8.15376 9.16699 8.6153 9.16699H23.3845C23.7948 9.16699 24.205 9.58366 24.205 10.0003V20.0003C24.205 20.4691 23.7948 20.8337 23.3845 20.8337H16.1538Z"
      fill={color}
    />
  </svg>
);

export default ChatsIcon;
